import { defineComponent, ref, provide, openBlock, createElementBlock, Fragment, renderSlot, createCommentVNode, createVNode } from 'vue';
import SsoButton from '../../SsoButton/src/SsoButton.vue.mjs';
import request from '../../../utils/request.mjs';
import { getPublishTimestamp } from '../../../utils/index.mjs';
import { PUBLIC_URL, PLATFORM, U_API_BASE } from '../../../utils/getConstant.mjs';

const __default__ = defineComponent({
  name: "TvbAnywhereConfig"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    env: null,
    platform: null
  },
  emits: [
    "error",
    "loginSuccess",
    "loginGuestSuccess"
  ],
  setup(__props, { emit: emits }) {
    const props = __props;
    const geoIp = ref(null);
    const languageList = ref(null);
    const currentLanguage = ref(null);
    const loginByLoading = ref(false);
    const loginBySuccess = ref(false);
    const loginByWaiting = ref(true);
    const userInfo = ref(null);
    const guestInfo = ref(null);
    const devices = ref(null);
    ;
    provide("env", props.env || "prod");
    provide("platform", props.platform || null);
    provide("geoIp", geoIp);
    provide("languageList", languageList);
    provide("currentLanguage", currentLanguage);
    provide("setCurrentLanguage", (language) => {
      currentLanguage.value = language;
    });
    provide("loginByLoading", loginByLoading);
    provide("setLoginByLoading", (loading) => {
      loginByLoading.value = loading;
    });
    provide("loginBySuccess", loginBySuccess);
    provide("setLoginBySuccess", (success) => {
      loginBySuccess.value = success;
    });
    provide("setLoginByWaiting", (waiting) => {
      loginByWaiting.value = waiting;
    });
    provide("userInfo", userInfo);
    provide("setUserInfo", (user) => {
      userInfo.value = user;
    });
    provide("guestInfo", guestInfo);
    provide("setGuestInfo", (guest) => {
      guestInfo.value = guest;
    });
    provide("devices", devices);
    provide("setDevices", (device) => {
      devices.value = device;
    });
    const disposeDefaultLanguage = (geo) => {
      request.get(
        `/headerfooter${props.env !== "prod" ? "_qa" : ""}/language-list.json?_t=${getPublishTimestamp()}`,
        {
          baseURL: PUBLIC_URL(props.env || "prod")
        }
      ).then(({ data }) => {
        var _a, _b;
        let languages = [];
        let languageCodes = data.reduce((p, c) => {
          if (c.code)
            p.push(c.code);
          return p;
        }, []);
        let languageCountrys = data.reduce((p, c) => {
          if (c.country)
            p.push(c.country);
          return p;
        }, []);
        let [country, language] = location.pathname.split("/").filter((s) => s);
        if (languageCodes.includes(country))
          language = country;
        if (languageCodes.includes(language)) {
          languages = data.filter((s) => s.code === language);
        } else if (localStorage.getItem("currentLanguage")) {
          languages = data.filter((s) => s.key === localStorage.getItem("currentLanguage"));
        } else if (country && languageCountrys.includes(country == null ? void 0 : country.toLocaleUpperCase())) {
          languages = data.filter((s) => s.country === (country == null ? void 0 : country.toLocaleUpperCase()));
        } else if ((geo == null ? void 0 : geo.country) && languageCountrys.includes((_a = geo == null ? void 0 : geo.country) == null ? void 0 : _a.toLocaleUpperCase())) {
          languages = data.filter((s) => {
            var _a2;
            return s.country === ((_a2 = geo == null ? void 0 : geo.country) == null ? void 0 : _a2.toLocaleUpperCase());
          });
        }
        if (!languages.length) {
          languages = data.filter((s) => s.code === "en");
        }
        languageList.value = data;
        currentLanguage.value = languages[0];
        localStorage.setItem("currentLanguage", ((_b = currentLanguage.value) == null ? void 0 : _b.key) || "EN");
        if (geo == null ? void 0 : geo.country)
          geo.country = geo.country === "MO" ? "US" : geo.country;
        geoIp.value = geo;
      }).catch((error) => {
        var _a;
        languageList.value = [
          {
            key: "en-US",
            name: "EN",
            code: "en",
            country: "US"
          }
        ];
        currentLanguage.value = languageList.value[0];
        localStorage.setItem("currentLanguage", ((_a = currentLanguage.value) == null ? void 0 : _a.key) || "EN");
        if (geo == null ? void 0 : geo.country)
          geo.country = geo.country === "MO" ? "US" : geo.country;
        geoIp.value = geo;
        console.error(error);
        emits("error", error);
      });
    };
    const getGeoIp = (authorization) => {
      sessionStorage.removeItem("geoIp");
      request.get(
        `/geoip/v2/check/platform/${PLATFORM(
          props.env || "prod",
          props.platform
        )}?_t=${getPublishTimestamp()}`,
        {
          baseURL: U_API_BASE(props.env || "prod"),
          headers: {
            Authorization: `Bearer ${authorization}`
          }
        }
      ).then(({ data }) => {
        data.display_country = data.country;
        if (data == null ? void 0 : data.country)
          data.country = data.country === "MO" ? "US" : data.country;
        sessionStorage.setItem("geoIp", encodeURIComponent(JSON.stringify(data)));
        disposeDefaultLanguage(data);
      }).catch((error) => {
        console.error(error);
        disposeDefaultLanguage({});
        emits("error", error);
      });
    };
    const loginSuccess = (user) => {
      getGeoIp(user.session_token);
      userInfo.value = user;
      emits("loginSuccess", user);
    };
    const loginGuestSuccess = (guest) => {
      getGeoIp(guest.session_token);
      guestInfo.value = guest;
      emits("loginGuestSuccess", guest);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        geoIp.value && !loginByWaiting.value ? renderSlot(_ctx.$slots, "default", { key: 0 }) : createCommentVNode("v-if", true),
        createVNode(SsoButton, {
          onLoginSuccess: loginSuccess,
          onLoginGuestSuccess: loginGuestSuccess
        })
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=Config.vue2.mjs.map
